import { MarketAppView } from 'domain/entity/market/marketApp';
import { Result } from 'domain/types';
import ReadMarketAppsClient from 'use-case/marketApps/read/readMarketAppsClient';
import ReadMarketAppsCriteria from 'use-case/marketApps/read/readMarketAppsCriteria';

export type ReadMarketAppsResult = Result<MarketAppView[]>;
export type ReadMarketApps = (criteria: ReadMarketAppsCriteria) => Promise<ReadMarketAppsResult>;

export default (readMarketAppsClient: ReadMarketAppsClient): ReadMarketApps => (
    criteria: ReadMarketAppsCriteria
): Promise<ReadMarketAppsResult> => readMarketAppsClient(criteria);
